import themeEditor from './themeEditor';

const LoginPage = () => {
  if (document.querySelectorAll('[data-section-type="INF-LoginPage"]').length === 0) {
    return;
  }

  if (document.querySelectorAll('[data-reset-password-success]').length > 0) {
    window.location.hash = '#password_reset_requested';
  }

  themeEditor();
};

export { LoginPage };
